import classNames from 'classnames'
import {useRef, useState, useEffect} from "react";

import Textarea from '@UI/Textarea'
import UploadFile from "@UI/UploadFile";
import {UploadMultipleFiles} from '@UI/UploadMultipleFiles/UploadMultipleFiles';
import {parseAcceptArray} from '@/utils/parseAcceptArray';
import { AnswerButton } from '../AnswerButton/AnswerButton'
import { useTaskHomeWork } from '../hooks/useTaskHomeWork'
import { useSelector } from "react-redux";
import { selectProfile } from '@store/profile.reducer';
import s from './DetailedResponse.module.css'
import { formateTime } from '@/helpers/formateTime';
import { VideoAnswer } from '../VideoAnswer/VideoAnswer';
import { useVideoState } from '../hooks/useVideoState';
import { useCanvas } from '@common/DrawingImage/canvas/useCanvas';
import DrawingImage from '@common/DrawingImage';

export const DetailedResponse = ({ type, ...props }) => {
  switch (type) {
    case 'decided': return <Decided {...props} />
    case 'correction': return <Correction {...props} />
    default: return <Task {...props} />
  }
}

const Correction = () => {
  return <div className={s.wrapper}>
    <Textarea className={classNames(s.textarea, s.textareaCorrection)} placeholder='Ответьте развернуто' disabled={true} />
    <UploadFile allowed={false} />
  </div>
}

const Decided = ({userRole, ...props}) => {
  const { video, videoType } = useVideoState(
        {
            video_source_type: props?.params?.result?.video_source_type,
            video_solution: props?.params?.result?.video_solution,
            video_solution_platform_media: props?.params?.result?.video_solution_platform_media,
            video_solution_iframe: props?.params?.result?.video_solution_iframe
        }
  );
  
  const userRoleFromStore = useSelector(selectProfile).role
  const answer = props?.params?.result?.answer
  const files = props?.params?.result?.answer_files ?? []

   //
  const {
    canvasRef,
    canvasState,
    canvasOperations,
    saveImage,
    resetCanvas,
    canvasStyle
  } = useCanvas({
    saveImageParams: {
      initialText: 'Идет отправка изображения',
      successText: 'Изображение успешно добавлено во вложения'
    },
    canvasInitParams: {
        initialText: 'Идет подготовка изображения к редактированию, пожалуйста, подождите',
        successText: 'Изображение готово к редактированию'
    }
  });
  const {
    imageUrl, setImageUrl, loading, setChangeImage, changeImage,
    brushColor, setBrushColor, brushWidth, setBrushWidth,
    isTextRegim, setIsTextRegim, canvasFont, isSaving,
    showCanvasText, canvasText, setCanvasText,
    xY
  } = canvasState;

  const {
    startDrawing, draw, stopDrawing, addText,
    undoLastAction, increaseScale, decreaseScale,
    saveCanvasText, changeCanvasFont
  } = canvasOperations;

  const handleSaveImage = {
    f: () => {
      saveImage((blob) => 
        props.teacherAnswer.addCommentFile({
          'comment_files': [blob],
          'work_id': props.homeWork_id,
          'task_id': props.id,
        }).then(res => {
          if (res.data.data?.length > 0) {
            props.updateList(res.data.data);
          }
        })
      );
    },
    text: 'Отправить изображение учащемуся' 
  }
  //код для конваса заканчивается здесь
  return (
      <div className={s.answerWrap}>
        <div className={s.description}>
          <span className={classNames(s.capsuleLeft, {[s.red]: false})}>
            {userRole === 'children' ? 'Ваш ответ' : 'Ответ учащегося'}
          </span>

          {answer ? (
              <Textarea className={classNames(s.textarea, s.textareaCorrection)} placeholder='Ответьте развернуто' disabled={true} value={answer}/>
          ) : (
              <span className='error'>Нет ответа</span>
          )}

          {
            files.map(file => <VievFile answer={file.path} {...{userRoleFromStore, changeImage, setImageUrl, loading}} />)
          }

      { userRoleFromStore == 'seminarian' && <button onClick={() => { setChangeImage((prevValue) => !prevValue) }} className={classNames(s.buttonText, 'backgroundNewGrey', 'backgroundNewYellow')}>
          {changeImage ? 'Свернуть' : 'Изменить изображение и отправить ученику'}
        </button>
      }
        <DrawingImage {
          ...{
            changeImage,
            imageUrl,
            setBrushColor,
            setBrushWidth,
            brushWidth,
            setIsTextRegim,
            changeCanvasFont,
            isSaving,
            isTextRegim,
            showCanvasText,
            saveCanvasText,
            canvasFont,
            startDrawing,
            draw,
            brushColor,
            undoLastAction,
            increaseScale,
            canvasRef,
            decreaseScale,
            handleSaveImage,
            loading,
            resetCanvas,
            stopDrawing,
            addText,
            canvasStyle,
            xY,
            canvasText,
            setCanvasText,
            title: 'Выберите изображение',
            tooltip: 'Вы можете выбрать любое изображение ученика для редактирования, кликнув по нему'
          }
        } />

        </div>
      {props?.params?.result?.time_spent &&
        <div className={s.estimation}>
          <span className={s.booble}>Потрачено время</span>
          <span className={s.booble}> {formateTime(props?.params?.result?.time_spent)}</span>
        </div>
      }
      {video && <VideoAnswer video={video} videoType={videoType} />}
      </div>
  )
}

const Task = ({ params, userRole, ...props }) => {
  const textareaRef = useRef();
  const [files, setFiles] = useState([])
  const [isEditing, setIsEditing] = useState(false);
  const { onAnswer, answer, status, hint, video, videoType } = useTaskHomeWork(params, props, true, files, false, setIsEditing)
  const [hideDownloadedFiles, setHideDownloadedFiles] = useState(false);

  const accept = parseAcceptArray(props?.mime)
  const defaultFiles = params?.result?.answer_files ?? []

  const onInputFiles = (files) => {
    if (!answer.get && files.length > 0) {
      answer.set('Ответ файлом')
    }
    setFiles(files)
  }

  const enableEditing = () => {
    params.setStatRowValues?.((prev) => {
        return prev.map((item) => (item.id === props.id ? {...item, value: 0} : item))
    })
    setIsEditing(true);
    setHideDownloadedFiles(true)
  };

  return <div className={s.answerWrap}>
    <Textarea
      ref={textareaRef}
      value={answer.get}
      onInput={e => answer.set(e.target.value)}
      className={s.textarea}
      placeholder='Ответьте развернуто'
      disabled={((status > 4 && !isEditing) || userRole === 'parent')}
    />

    {!props?.cant_upload_files &&
    <div style={{marginBottom: 10}}>
      <UploadMultipleFiles hideDownloadedFiles={hideDownloadedFiles} onInput={onInputFiles} disabled={((status > 4 && !isEditing) || userRole === 'parent')} accept={accept} maxFiles={10} defaultFiles={defaultFiles} />
    </div>
    }

    <div className={s.actionContainer}>
      <AnswerButton hintForChild={params.hintForChild} hintAfterAllAttempts={props.hint_after_all_attempts} {...{ status, onAnswer, hint, video, videoType, isEditing }} isDetailedResponse={true} />

      {!isEditing && status > 4 && userRole !== 'parent' && (
        <button style={{ marginTop:'auto'}} className='btn' onClick={enableEditing}>
          Изменить ответ
        </button>
      )}
    </div>
  </div>
}



const VievFile = ({userRoleFromStore, answer, changeImage, setImageUrl, loading}) => {
  const isImg = (str) => (str.includes('.jpeg') || str.includes('.png') || str.includes('.jpg') || str.includes('.webp') || str.includes('.svg'));
  //const isImg = (str) => (str.includes('.jpeg') || str.includes('.png') || str.includes('.jpg') || str.includes('.webp') || str.includes('.svg') || str.includes('.heic') || str.includes('.HEIC'));
  const imgSrc = process.env.REACT_APP_PATH_FILE + '/' + answer;
  if(answer) {
    if(isImg(answer) && userRoleFromStore !== 'children') {
      return (
        <img 
          onClick={() => {
            if(changeImage){
              if(loading){
                return;
              }
              setImageUrl(imgSrc)
            }
            else{
              window.open(imgSrc, '_blank');
            }
          }}
          className={s.editable} 
          src={imgSrc} />
      )
    }
    else{
      return <a href={imgSrc} className={s.capsuleRight} target='_blank' rel="noreferrer">Открыть файл</a>;
    }
  }
  else{
    return 'Учащийся не прикрепил файл';
  }
}
